import React from 'react'
import _ from 'lodash'
import { shallowEqual, useSelector } from 'react-redux'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined'
import {
  CellContainer,
  Container,
  LeftCellContainer,
  RoomList,
  StyledDivider,
} from './Styled'
import { isMediaWidthMoreThan, replaceProtocol } from 'src/utils/lib'

const JoinButton = ({ link, isWidthLg }) => (
  <>
    {isWidthLg ? <StyledDivider /> : ''}
    <Button
      startIcon={<VideocamOutlinedIcon />}
      onClick={() => window.open(`${replaceProtocol(link)}`, '_blank')}
    >
      เข้าเรียน
    </Button>
  </>
)

const TrainingCell = () => {
  const trainingRoom = useSelector(
    (state) => state.registration.data.trainingRoom,
    shallowEqual
  )

  const isWidthLg = isMediaWidthMoreThan('sm')
  return (
    <>
      {trainingRoom.map((item, index) => {
        const fullDate = `${item.dateDay} ${item.dateMonth} ${item.dateYear}`
        const fullTime = `${item.startTime} - ${item.endTime}`
        // DMSSUP-419: online หลายห้อง แสดงทุกห้องพร้อมปุ่มเข้าเรียนของแต่ละห้อง
        const onlineRooms = _.get(item, 'onlineRooms', [])
        const isMultiOnlineRoom =
          item.roomType === 'ONLINE_ROOM' && onlineRooms.length > 1

        return (
          <Container key={index}>
            <LeftCellContainer>
              <Typography variant="body1" sx={{ width: '140px' }}>
                {fullDate}
              </Typography>
              <Typography
                variant="body1"
                sx={{ width: '200px' }}
                color="text.secondary"
              >
                {fullTime}
              </Typography>
            </LeftCellContainer>
            {isMultiOnlineRoom ? (
              <RoomList>
                {onlineRooms.map((room, roomIndex) => (
                  <CellContainer key={roomIndex}>
                    <Typography
                      variant="body1"
                      sx={{ width: 'auto' }}
                      color="text.secondary"
                    >
                      {room.roomName}
                    </Typography>
                    {!_.isEmpty(room.link) && (
                      <JoinButton link={room.link} isWidthLg={isWidthLg} />
                    )}
                  </CellContainer>
                ))}
              </RoomList>
            ) : (
              <CellContainer>
                <Typography
                  variant="body1"
                  sx={{ width: 'auto' }}
                  color="text.secondary"
                >
                  {item.roomName}
                </Typography>

                {item.roomType === 'ONLINE_ROOM' && (
                  <JoinButton link={item.link} isWidthLg={isWidthLg} />
                )}
              </CellContainer>
            )}
          </Container>
        )
      })}
    </>
  )
}

export default TrainingCell
